module.exports = __webpack_public_path__ + "img/9788934996996.096a94a7.jpg";